export default {
  methods: {
    shouldDisableButton(data) {
      if (data == null || data == undefined) {
        return true;
      } else {
        if (typeof data == "string") {
          if (data.length < 1) {
            return true;
          } else {
            return false;
          }
        } else if (Array.isArray(data)) {
          if (data.length == 0) {
            return true;
          } else {
            return false;
          }
        } else if (typeof data == "object") {
          let keysInObject = Object.keys(data);
          if (keysInObject.length < 1) {
            return true;
          } else {
            for (let i = 0; i < keysInObject.length; i++) {
              let currentKey = keysInObject[i];
              if (this.shouldDisableButton(data[currentKey])) {
                return true;
              }
            }
            return false;
          }
        } else {
          return false;
        }
      }
    },
  },
};
